import React, { useState, useContext } from "react";
import useReactRouter from "use-react-router";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { FaFacebook, FaGooglePlus } from "react-icons/fa";
import { useSnackbar } from "notistack";
import {
  Typography,
  Grid,
  TextField,
  IconButton,
  Fab,
  CircularProgress,
  Divider,
  Button,
} from "@material-ui/core";
import {
  MdAccountCircle,
  MdVisibility,
  MdVisibilityOff,
  MdLock,
  MdLockOpen,
} from "react-icons/md";
import { postLogin } from "../../API/Auth";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: { width: "100%", height: "100%" },

  PaperRight: {
    height: "100%",
    borderRadius: "2rem",
    boxShadow: "unset",
    // backgroundColor: "rgba(255,255,255,0.5)"
  },

  input: {
    color: "black",
  },
  card: {
    padding: theme.spacing(3, 2),
    minWidth: 500,
  },

  itemTextField: { width: "calc(100% )" },

  formControl: {
    width: "100%",
    "& .MuiFormLabel-root": {
      color: theme.palette.main,
    },
    "& label.Mui-focused": {
      color: theme.palette.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.main,
    },
    "& .MuiOutlinedInput-root": {
      fontWeight: 200,
      "& fieldset": {
        borderColor: theme.palette.main,
        borderRadius: `3rem`,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.main,
      },
    },
    "& .MuiOutlinedInput-inputAdornedStart": {
      paddingLeft: 10,
    },
  },

  focusIcon: {
    color: theme.palette.primary.main,
  },
  blurIcon: {
    color: "rgba(0,0,0,0.5)",
  },
  signupText: {
    color: theme.palette.primary.main,
    textDecoration: "unset",
  },
  forgotText: {
    textDecoration: "unset",
    fontWeight: 400,
    cursor: "pointer",
  },
  extendedIcon: { marginRight: theme.spacing(1) },
  fab: {
    textTransform: "unset",
    width: "100%",
    boxShadow: "unset",
  },
  gridSignin: { display: "flex" },
  center: { textAlign: "center" },
  loginsocial: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonsocial: {
    textTransform: "unset",
  },
  iconsocial: {
    border: "1px dashed",
    borderRadius: 14,
    transition: "transform .2s",
    "&:hover": {
      transform: "scale(1.5)",
    },
  },
}));
const Logincomp = ({ setpage }) => {
  const classes = useStyle();
  const { history } = useReactRouter();
  const { enqueueSnackbar } = useSnackbar();
  const [state, setstate] = useState({ username: "", password: "" });
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const [focusIcon, setFocusIcon] = useState({
    email: false,
    password: false,
    showPassword: false,
  });
  const [loading, setloading] = useState(false);

  const handlerSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    const login = await postLogin(state.username, state.password);

    setTimeout(() => {
      if (login.token) {
        localStorage.setItem("token", login.token);
        localStorage.setItem("role", login.user_role);
        localStorage.setItem("uid", login.user_id);
        history.replace(`/mea-auth?token=${login.token}`);
        enqueueSnackbar(lang.LogingIn, {
          variant: "success",
        });
      } else {
        if (login.status.code === 401) {
          enqueueSnackbar(lang.IncorrectEmail, {
            variant: "error",
          });
        } else {
          enqueueSnackbar(login.status.message, {
            variant: "error",
          });
        }
      }
      // if (state.username === "admin") {
      //   localStorage.setItem("token", "admin");
      //   history.replace(`/mea-auth?token=admin`);
      // } else {
      //   localStorage.setItem("token", "user");
      //   history.replace(`/mea-auth?token=user`);
      // }

      setloading(false);
    }, 1000);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ margin: "1rem" }}>
        <Typography
          variant="h5"
          component="p"
          align="center"
          style={{ fontWeight: 600, padding: "1rem" }}
        >
          {lang.Getmorething}
        </Typography>

        <div
          style={{
            display: "flex",
            paddingBottom: "3rem",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" component="p" style={{ fontWeight: 400 }}>
            {lang.Donthaveaccount} ?
          </Typography>
          <Typography
            variant="h6"
            component="p"
            color="primary"
            style={{ fontWeight: 400, paddingLeft: "1rem", cursor: "pointer" }}
            onClick={() => {
              setpage(1);
              history.push("/user/register");
            }}
          >
            {lang.Createhere}
          </Typography>
        </div>

        <form onSubmit={handlerSubmit}>
          {/* ======================= TEXT FIELD =========================== */}
          <Grid container>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item className={classes.itemTextField}>
                  <TextField
                    id="login-input-email"
                    label={lang.Email}
                    name="Email"
                    type="text"
                    variant="outlined"
                    className={classes.formControl}
                    classes={{ root: classes.textFieldColour }}
                    onFocus={(e) => {
                      setFocusIcon({ ...focusIcon, email: true });
                    }}
                    onBlur={(e) => {
                      setFocusIcon({ ...focusIcon, email: false });
                    }}
                    onChange={(e) => {
                      setstate({
                        ...state,
                        username: e.target.value,
                      });
                    }}
                    required
                    InputProps={{
                      className: classes.input,

                      startAdornment: (
                        <MdAccountCircle
                          size={28}
                          className={clsx(
                            focusIcon.email
                              ? classes.focusIcon
                              : classes.blurIcon
                          )}
                        />
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid
                  item
                  className={classes.itemTextField}
                  style={{ marginTop: "0.8rem" }}
                >
                  <TextField
                    label={lang.Password}
                    className={classes.formControl}
                    id="login-input-password"
                    name="password"
                    variant="outlined"
                    type={focusIcon.showPassword ? "text" : "password"}
                    classes={{ root: classes.textFieldColour }}
                    onFocus={(e) => {
                      setFocusIcon({
                        ...focusIcon,
                        password: true,
                      });
                    }}
                    onBlur={(e) => {
                      setFocusIcon({
                        ...focusIcon,
                        password: false,
                      });
                    }}
                    onChange={(e) => {
                      setstate({
                        ...state,
                        password: e.target.value,
                      });
                    }}
                    required
                    InputProps={{
                      className: classes.input,
                      startAdornment: (
                        <MdLock
                          size={28}
                          className={clsx(
                            focusIcon.password
                              ? classes.focusIcon
                              : classes.blurIcon
                          )}
                        />
                      ),

                      endAdornment: (
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={() => {
                            setFocusIcon({
                              ...focusIcon,
                              showPassword: !focusIcon.showPassword,
                            });
                          }}
                        >
                          {focusIcon.showPassword ? (
                            <MdVisibility />
                          ) : (
                            <MdVisibilityOff />
                          )}
                        </IconButton>
                      ),
                    }}
                  ></TextField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            style={{
              paddingTop: "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography
                className={classes.forgotText}
                onClick={() => {
                  history.push("/user/forgot-password");
                }}
              >
                {lang.ForgotPassword}
              </Typography>
            </Grid>
          </Grid>
          {/* =============================== BUTTON ================ */}
          <Grid
            container
            spacing={2}
            style={{
              paddingTop: "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              className={classes.gridSignin}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Fab
                variant="extended"
                aria-label="signin"
                color="primary"
                className={classes.fab}
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress
                    size={24}
                    className={classes.extendedIcon}
                    color="secondary"
                  />
                ) : (
                  <MdLockOpen
                    size={24}
                    className={classes.extendedIcon}
                    style={{ fill: "white" }}
                  />
                )}
                <Typography
                  variant="h6"
                  component="p"
                  style={{ color: "white", fontWeight: 600 }}
                >
                  {lang.Signin}
                </Typography>
              </Fab>
            </Grid>
            <Grid
              item
              xs={12}
              className={classes.gridSignin}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Fab
                variant="extended"
                aria-label="signin"
                color="primary"
                className={classes.fab}
                style={{
                  background: "white",
                  border: "1px solid #00000099",
                }}
                onClick={async () => {
                  let a = document.createElement("a");
                  a.href = `${process.env.REACT_APP_API_URL}/oauth/mea/login`;
                  a.target = "_blank";
                  a.click();
                }}
              >
                <Typography
                  variant="h6"
                  component="p"
                  color="textPrimary"
                  style={{ fontWeight: 600 }}
                >
                  {lang.SigninMEA}
                </Typography>
              </Fab>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.gridSignin}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Divider style={{ width: "100%" }} />
            </Grid>

            <Grid item xs={12} className={classes.loginsocial}>
              <Button
                size="large"
                // disabled
                onClick={() => {
                  let a = document.createElement("a");
                  a.href = `${process.env.REACT_APP_API_URL}/oauth/facebook/login`;
                  a.target = "_self";
                  a.click();
                }}
                className={classes.buttonsocial}
                startIcon={
                  <FaFacebook
                    className={classes.iconsocial}
                    color="#1e4fad"
                    //color="#bfbfbf"
                    size={28}
                  />
                }
              >
                <Typography
                  variant="h6"
                  component="p"
                  color="inherit"
                  style={{ fontWeight: 600 }}
                >
                  Facebook
                </Typography>
              </Button>

              <Button
                size="large"
                onClick={() => {
                  let a = document.createElement("a");
                  a.href = `${process.env.REACT_APP_API_URL}/oauth/google/login`;
                  a.target = "_self";
                  a.click();
                }}
                className={classes.buttonsocial}
                startIcon={
                  <FaGooglePlus
                    className={classes.iconsocial}
                    color="#fc4d3f"
                    size={28}
                  />
                }
              >
                <Typography
                  variant="h6"
                  component="p"
                  color="textPrimary"
                  style={{ fontWeight: 600 }}
                >
                  Google
                </Typography>
              </Button>
            </Grid>
            {/* <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
             
            </Grid> */}
          </Grid>
        </form>
      </div>
    </div>
  );
};

export default Logincomp;
